<div class="row">
  <div class="col-sm-6" [style.paddingRight]="0">
    <mat-card>
      <mat-card-content class="container-fluid">
        <app-timeline
          [timelineRecords]="timelineList()"
          [disabled]="!(canCreate$ | async)"
          [haveAccess]="isOwner()"
          (createNote)="createNote()"
          (editNote)="editNote($event)"
          (deleteNote)="deleteNote($event)"
          (download)="download($event)"
        />
      </mat-card-content>
    </mat-card>
  </div>

  <div class="col-sm-6">
    <mat-card>
      <mat-card-content class="container-fluid">
        <app-attachments [attachments]="attachments()" />
      </mat-card-content>
    </mat-card>
  </div>
</div>
